import classnames from "classnames";
import styles from "./DataCard.module.scss";

const DataCard = ({ className, data, minHeight }) => {
  const { miles, size, cargo } = data || {};

  return (
    <div className={classnames(styles.wrapper, className)} style={{ minHeight }}>
      <div className={styles.group}>
        <span className={styles.title}>Miles:</span>
        <p className={styles.value}>{miles}</p>
      </div>

      <div className={styles.group}>
        <span className={styles.title}>Sug. truck size:</span>
        <p className={styles.value}>
          {size && size?.charAt(0) + size?.slice(1).toLowerCase()}
        </p>
      </div>

      <div className={styles.group}>
        <span className={styles.title}>Pieces:</span>
        <p className={styles.value}>{cargo?.pieces}</p>
      </div>

      <div className={styles.group}>
        <span className={styles.title}>Weight:</span>
        <p className={styles.value}>{cargo?.weight}</p>
      </div>

      <div className={styles.group} style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
        <span className={styles.title}>Dims:</span>
        <p className={styles.value}>{cargo?.dimensions}</p>
      </div>

      <div className={styles.group}>
        <span className={styles.title}>Stackable:</span>
        <p className={styles.value}>{cargo?.stackable ? "Yes" : "No"}</p>
      </div>

      <div className={styles.group}>
        <span className={styles.title}>Hazardous:</span>
        <p className={styles.value}>{cargo?.hazardous ? "Yes" : "No"}</p>
      </div>

      <div className={styles.group}>
        <span className={styles.title}>FAST load:</span>
        <p className={styles.value}>{cargo?.fastLoad ? "Yes" : "No"}</p>
      </div>

      <div className={styles.group}>
        <span className={styles.title}>Dock level:</span>
        <p className={styles.value}>{cargo?.dockLevel ? "Yes" : "No"}</p>
      </div>
    </div>
  );
};

export default DataCard;
